import { Router } from '@angular/router';
import { CURRENT_CLAIM_NUMBER } from '@prcins/constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
export class ClaimNavigationService {
    constructor(router) {
        this.router = router;
    }
    navigateToClaim(claimNumber, queryParams) {
        sessionStorage.setItem(CURRENT_CLAIM_NUMBER, claimNumber);
        this.router.navigate(['/eservice/home/claims'], { queryParams });
    }
    canActivate() {
        this.router.navigate(['/eservice/home/claims/claimslist']);
        return false;
    }
}
ClaimNavigationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ClaimNavigationService_Factory() { return new ClaimNavigationService(i0.ɵɵinject(i1.Router)); }, token: ClaimNavigationService, providedIn: "root" });
